import {elementNameConst, shapeTypeConst} from '../../../conf';

/**
 * 拓扑插件-自定义图片图形-扩展
 */
export default {
  name: 'customImage',
  type: elementNameConst.node,
  options: {
    /**
     * 绘制节点，包含文本
     * @param {Object} cfg 节点的配置项
     * @param {Group} group 图形分组，节点中的图形对象的容器
     * @return {G.Shape} 绘制的图形，通过 node.get('keyShape') 可以获取到
     */
    draw(cfg, group) {
      const demo = {
        x: 0,
        y: 0,
        img: cfg?.iconContent,
        ...cfg
      };
      console.log(cfg, '数据', demo);
      return group.addShape(shapeTypeConst.image, {
        attrs: {
          x: 0,
          y: 0,
          img: cfg?.iconContent,
          ...cfg
        },
        name: 'image-shape'
      });
    }
  },
  // 继承节点名
  extendedNodeName: shapeTypeConst.image
};
